export const getDocNumberElementViewPayload = (
	rowData,
	elementViewKey,
	screenKey,
) => ({
	elementId: rowData.id,
	oWarehouseId: rowData.oWarehouseId,
	transaction: rowData,
	elementViewKey,
	...(screenKey ? { screenKey } : {}),
});
